<template>
  <div class="about-container">
    <div class="top-banner">
      <img src="@/images/u424.png" alt="顶部横幅" class="banner-img" />
    </div>

    <section class="company-intro">
      <div class="intro-content">
        <div class="intro-image">
          <img src="@/images/image.png" alt="公司形象图" class="company-img" />
        </div>
        
        <div class="intro-text">
          <div class="text-decoration left-decoration">
            <img src="@/images/u426.svg" alt="装饰图标" class="decor-icon" />
          </div>
          
          <div class="text-content">
            <p class="intro-paragraph">
              杭州古峰智能科技有限公司是一家专注于为企业提供定制化 WMS 系统及全场景读码设备一体化供应链解决方案的高新技术企业。公司深耕物流仓储数字化领域，以 “硬件 + 软件” 双轮驱动，助力医疗、食品、零售、制造业等行业突破仓储管理瓶颈，实现 “信息流与实物流的实时同步”。2022 年 6 月，公司荣获瞪羚企业称号，并拥有 30 多项相关专利与软著。
            </p>
          </div>
          
          <div class="text-decoration right-decoration">
            <img src="@/images/u427.svg" alt="装饰图标" class="decor-icon" />
          </div>
        </div>
      </div>
    </section>


    <section class="company-advantages">
      <ul class="advantages-list">
        <li class="advantage-item">
          <img src="@/images/ahk01.png" alt="强大的研发能力" class="advantage-img" />
          <span class="advantage-text">强大的研发能力</span>
        </li>   
        <li class="advantage-item">
          <img src="@/images/ahk02.png" alt="全过程质量监控" class="advantage-img" />
          <span class="advantage-text">全过程质量监控</span>
        </li>  
        <li class="advantage-item">
          <img src="@/images/ahk03.png" alt="定制化方案规划" class="advantage-img" />
          <span class="advantage-text">定制化方案规划</span>
        </li>  
        <li class="advantage-item">
          <img src="@/images/ahk04.png" alt="完善的售后服务" class="advantage-img" />
          <span class="advantage-text">完善的售后服务</span>
        </li>   
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutUs'
}
</script>

<style scoped>

.about-container {
  width: 100%;
  font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
  overflow-x: hidden;
}


.top-banner {
  width: 100%;
  overflow: hidden;
}

.banner-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}


.company-intro {
  padding: 60px 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.intro-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px;
}

.intro-image {
  flex: 0 0 auto;
}

.company-img {
  width: 350px;
  height: auto;
  max-width: 100%;
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.08);
  border-radius: 8px;
}

.intro-text {
  flex: 1;
  display: flex;
  position: relative;
  max-width: 800px;
}

.text-decoration {
  position: absolute;
  display: flex;
  align-items: center;
}

.left-decoration {
  left: 0;
  top: 0;
  bottom: 0;
}

.right-decoration {
  right: 0;
  top: 0;
  bottom: 0;
  justify-content: flex-end;
}

.decor-icon {
  width: 30px;
  height: auto;
}

.text-content {
  flex: 1;
  margin: 0 60px;
}

.intro-paragraph {
  font-size: 18px;
  line-height: 1.8;
  color: #333;
  margin: 0;
  text-align: justify;
}


.company-advantages {
  background: url(@/images/abouybg.png) no-repeat center;
  background-size: cover;
  padding: 80px 20px;
  margin-top: 20px;
}

.advantages-list {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 60px;
}

.advantage-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s ease;
}

.advantage-item:hover {
  transform: translateY(-8px);
}

.advantage-img {
  width: 127px;
  height: 114px;
  object-fit: contain;
  margin-bottom: 15px;
}

.advantage-text {
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}


@media (max-width: 992px) {
  .intro-content {
    flex-direction: column;
    gap: 30px;
  }
  
  .intro-text {
    width: 100%;
  }
  
  .text-content {
    margin: 0 40px;
  }
  
  .advantages-list {
    gap: 40px;
  }
}

@media (max-width: 768px) {
  .company-intro {
    padding: 40px 20px;
  }
  
  .text-content {
    margin: 0 30px;
  }
  
  .intro-paragraph {
    font-size: 16px;
    line-height: 1.7;
  }
  
  .advantages-list {
    gap: 30px;
  }
  
  .advantage-img {
    width: 100px;
    height: auto;
  }
  
  .advantage-text {
    font-size: 16px;
  }
  
  .company-advantages {
    padding: 60px 20px;
  }
}

@media (max-width: 576px) {
  .advantages-list {
    flex-direction: column;
    gap: 25px;
  }
  
  .advantage-item {
    width: 100%;
    max-width: 200px;
  }
  
  .text-decoration {
    display: none;
  }
  
  .text-content {
    margin: 0;
  }
}
</style>